import React from "react";
import Showcase from "../components/showcase";
import Articles from "./articles";

const Home = () => {
  return (
    <>
      <Showcase />
      <Articles />
    </>
  );
};

export default Home;
